// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"200d4171","496":"8d8889c6","875":"b12ee5fe"}[chunkId] + ".chunk.js";
};